function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.528
}, /*#__PURE__*/React.createElement("g", {
  fill: "#53585C"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.375.75c.621 0 1.125.504 1.125 1.125v.375h3V3h-.75v7.125c0 .621-.504 1.125-1.125 1.125h-5.25c-.621 0-1.125-.504-1.125-1.125V3H1.5v-.75h3v-.375C4.5 1.254 5.004.75 5.625.75zM9 3H3v7.125c0 .207.168.375.375.375h5.25c.207 0 .375-.168.375-.375V3zM6.375 4.5V9h-.75V4.5h.75zm1.5 0V9h-.75V4.5h.75zm-3 0V9h-.75V4.5h.75zm1.5-3h-.75c-.207 0-.375.168-.375.375v.375h1.5v-.375c0-.207-.168-.375-.375-.375z",
  transform: "translate(-1064 -287) translate(955 275) translate(109 12)"
})))));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.9b4fe3b0.svg";
export { ForwardRef as ReactComponent };